// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1spfx","messages":"Chat_messages__2g9UX","dateDivider":"Chat_dateDivider__Xr1I8"};